import { Pipe, PipeTransform } from "@angular/core";
import { PaymentResponse } from "@models/payment";

export interface PixUiState {
  qrCodeUrl: string;
  qrCodeImageUrl: string;
  copyPasteCode: string;
  expiresAt: string;
  amount: number;
}

//
// Pipe
//
@Pipe({
  name: "mapPixResponse",
  standalone: true,
  pure: true,
})
export class MapPixResponsePipe implements PipeTransform {
  transform(response: PaymentResponse | null | undefined): PixUiState | null {
    if (!response) {
      return null;
    }

    const hasNewPix = !!response.pix_data?.qr_code;

    if (hasNewPix) {
      return {
        qrCodeUrl: response.pix_data!.qr_code ?? "",
        qrCodeImageUrl: response.pix_data!.qr_code_url ?? "",
        copyPasteCode: response.pix_data!.qr_code ?? "",
        expiresAt: response.pix_data!.expires_at ?? "",
        amount: response.pix_data!.amount ?? 0,
      };
    }

    return {
      qrCodeUrl: response.qr_code ?? "",
      qrCodeImageUrl: response.pix_data?.qr_code_url ?? "",
      copyPasteCode: response.pix_data?.copy_paste_code ?? "",
      expiresAt: response.pix_data?.expires_at ?? "",
      amount: response.pix_data?.amount ?? 0,
    };
  }
}
